import React from 'react'
import { menu1List } from 'components/Header/headerMenuConfig'

const HeaderMenu1 = () => {
  return <div className='HeaderMenu1'>{menu1List}</div>
}

export default HeaderMenu1
